import { StreamingPlayerImage } from '@heardis/stream-contracts';
import classes from './Image.module.css';

type ImageProps = {
  height?: string;
  width?: string;
  onError?: () => void;
} & StreamingPlayerImage;

function getScalingFactorbyBlurValue(blur: string) {
  const blurWithoutPx = blur.split('px')[0];
  return 1 + Number(blurWithoutPx) / 100;
}

function Image({ url, alt, blur, position, fit, height, width, onError }: ImageProps) {
  /** @TODO 0 as value can be removed with the next contracts release  */
  const withBlur = blur && blur !== '0px' && blur !== '0';

  return (
    <img
      className={classes.image}
      src={url}
      alt={alt}
      style={{
        filter: withBlur ? `blur(${blur})` : undefined,
        transform: withBlur ? `scale(${getScalingFactorbyBlurValue(blur)})` : undefined,
        objectPosition: position,
        /** @TODO how should we handle this "as any"? */
        objectFit: fit as any,
        height,
        width,
      }}
      onError={onError}
    />
  );
}

export default Image;
